import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DateAdapter } from '@angular/material/core';
import { TranslateService } from '@ngx-translate/core';
import { SideNavToggle } from '../models/sidenavToggle';
import { Brand } from '../models/brand';
import { NavbarMenu } from '../models/navbarMenu';
import { User } from '../models/user';
import { HelperService } from 'src/services/helperService';
import { Router } from '@angular/router';
import { LookAndFeelWebView } from 'src/models/LookAndFeelWebView';
import { PublicSiteConfig } from '../services/publicSiteConfig.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.sass'],
    standalone: false
})
export class AppComponent implements OnInit {
  isSidenavExpanded: boolean = false;
  screenWidth: number = 0;
  showBusyIndicator: boolean = false;
  isSessionActive: boolean = false;
  isWebView: boolean = false;
  sessionFailed:boolean = false
  brand = {} as Brand;
  webview = {} as LookAndFeelWebView;
  user = {} as User;
  navbarMenus: NavbarMenu[] = [];

  constructor(
    public helperService: HelperService,
    private router: Router,
    public PublicSiteConfig: PublicSiteConfig,
    private route: ActivatedRoute,
    private dateAdapter: DateAdapter<Date>,
    private translate: TranslateService
  ) {
    this.showBusyIndicator = true;

    this.translate.setDefaultLang('en-US'); // Default language

  }

  ngOnInit(): void {
    this.helperService.userRetrieve.subscribe((MessageError) => {
      console.log(MessageError)
      if(MessageError === "error"){
        this.isSessionActive = false;
        this.showBusyIndicator = false;
        this.sessionFailed = false;
      }
      else if (MessageError === "sessionFailed")
      {
        this.isSessionActive = true;
        this.showBusyIndicator = true;
        this.sessionFailed = true;

      }
      
      else{  this.personalizeSite();}
    
    });

    const params1 = window.location.pathname.split('/');
    this.setLanguageByCountryCode(Number(params1[4]));

    this.isWebView = this.ValidateWebView(); //validar url
    if (this.isWebView) {
      this.isSessionActive = false;
    } else {
      // funciones para Habilitar/deshabilitar el login
      this.isSessionActive = this.ValidateShowLogin(); //Login habilitado
      // this.isSessionActive = true //login deshabilitado
    }
  }

  onToggleSidenav(sideNav: SideNavToggle): void {
    this.isSidenavExpanded = sideNav.isExpanded;
    this.screenWidth = sideNav.screenWidth;
  }

  ValidateWebView(): boolean {
    let dir = window.location.href;
    if (dir.toLowerCase().indexOf('/webview/') > -1) return true;
    else return false;
  }

  loadBrandTheming(): void {
    document.documentElement.style.setProperty(
      '--brand-primary-color',
      this.brand.primaryColor
    );
    document.documentElement.style.setProperty(
      '--brand-secondary-color',
      this.brand.secondaryColor
    );
    document.documentElement.style.setProperty(
      '--brand-tertiary-color',
      this.brand.tertiaryColor
    );
    document.documentElement.style.setProperty(
      '--brand-neutral-color',
      this.brand.neutralColor
    );
    document.documentElement.style.setProperty(
      '--brand-complementary-purple',
      this.brand.complementary1
    );
    document.documentElement.style.setProperty(
      '--brand-complementary-yellow',
      this.brand.complementary2
    );
    document.documentElement.style.setProperty(
      '--brand-complementary-green',
      this.brand.complementary3
    );
    document.documentElement.style.setProperty(
      '--brand-complementary-red',
      this.brand.complementary4
    );
  }

  personalizeSite(): void {
    this.user = this.helperService.user;
    this.brand = this.helperService.brand;
    this.navbarMenus = this.helperService.modules;
    this.loadBrandTheming();
    this.showBusyIndicator = false;
    this.sessionFailed = false;
  }

  ValidateShowLogin(): boolean {
    let email = this.getCookie('Email');
    if (email == '') {
      return false;
    }
    return true;
  }

  private getCookie(name: string) {
    let ca: Array<string> = document.cookie.split(';');
    let caLen: number = ca.length;
    let cookieName = `${name}=`;
    let c: string;

    for (let i: number = 0; i < caLen; i += 1) {
      c = ca[i].replace(/^\s+/g, '');
      if (c.indexOf(cookieName) == 0) {
        return c.substring(cookieName.length, c.length);
      }
    }
    return '';
  }

  // Set Calendars Translation
  setLanguageByCountryCode(countryCode: number | null) {
    if (!countryCode) return;

    let lang = 'en-US'; // Default to English
    switch (countryCode) {
      case 3:
        lang = 'es-CO';
        this.dateAdapter.setLocale('es-CO');
        break;
      // Add more country code cases as needed
      default:
        lang = 'en-US';
        this.dateAdapter.setLocale('en-US');
        break;
    }
    this.translate.use(lang);
  }
}
